import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper'
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect'

// redux-auth-wrapper package has introduced following warning.
// Warning: Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code.
// There is already an open issue related to same here: https://github.com/mjrussell/redux-auth-wrapper/issues/266

const locationHelper = locationHelperBuilder({})

export const userIsAuthenticated = connectedRouterRedirect({
  // The url to redirect user to if they fail
  redirectPath: '/',
  allowRedirectBack: false,
  // Determine if the user is authenticated or not
  authenticatedSelector: (state) => state.entities.user.isLoggedIn,
  // A nice display name for this check
  wrapperDisplayName: 'UserIsAuthenticated',
})

// Governance / Data Controls Engine are restricted to Pixm Admin (PA). A
// non-PixmAdmin (or logged-out) user is redirected to the landing page.
export const userIsPixmAdmin = connectedRouterRedirect({
  redirectPath: '/',
  allowRedirectBack: false,
  authenticatedSelector: (state) =>
    state.entities.user.isLoggedIn && state.entities.user.roles === 'PixmAdmin',
  wrapperDisplayName: 'UserIsPixmAdmin',
})

export const userIsNotAuthenticated = connectedRouterRedirect({
  // This sends the user either to the query param route if we have one, or to the landing page if none is specified and the user is already logged in
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/customers:id/incidents:id',
  // This prevents us from adding the query parameter when we send the user away from the login page
  allowRedirectBack: false,
  // This prevents us from adding the query parameter when we send the user away from the login page
  // Determine if the user is authenticated or not
  authenticatedSelector: (state) => !state.entities.user.isLoggedIn,
  // A nice display name for this check
  wrapperDisplayName: 'UserIsNotAuthenticated',
})
